import axios from '../../axios';
import { UPDATE_GLOBAL_SETTING, USER_GLOBAL_SETTINGS, GET_WP_QR_CODE, GET_WP_SETTING, GET_WP_MESSAGE, GET_WP_MESSAGE_PDF } from '../types';
import { toast } from 'react-toastify';

export const updateUserGlobalSettings = (payload) => async (dispatch) => {
   try {
      const res = await axios.post(`/settings/update`, payload);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_GLOBAL_SETTING, payload: res.data.data });

         setTimeout(() => {
            toast.success('User settings updated successfully!');
         }, 1000);
         return res.data;
      } else {
         toast.error('Failed to update user settings. Please try again.');
         return res.data;
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.warn(err.response.data.message);
         return err.response.data;
      }
      if (
         err.response &&
         err.response.data &&
         err.response.data.errors &&
         err.response.data.errors[0] &&
         err.response.data.errors[0].message
      ) {
         toast.error(err.response.data.errors[0].message);
         return err.response.data;
      } else {
         toast.error('Failed to update user settings. Please try again.');
         return err.response.data;
      }
   }
};

export const userGlobalSettings = () => async (dispatch) => {
   try {
      const res = await axios.get('/settings/all');
      if (res.data.code === 1) {
         dispatch({ type: USER_GLOBAL_SETTINGS, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getWpQrCode = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/settings/wpQr', { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_WP_QR_CODE, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getWpSetting = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/settings/getUrl', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: GET_WP_SETTING, payload: res.data.data });
         return res.data; // Return the result for handling in the component
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response.data.message);
      }
      throw err; // Re-throw to handle in the component
   }
};

export const sendWhatsAppMessage = (formData) => async (dispatch) => {
   try {
      console.log('Sending WhatsApp message with data:', typeof formData.companyId, formData.companyId);
      const res = await axios.post('/settings/sendWpMsg', formData);

      if (res.data.code === 1) {
         dispatch({ type: GET_WP_MESSAGE, payload: res.data.data });
         toast.success('WhatsApp message sent successfully!');
         return res.data; // Return the result for handling in the component
      } else {
         toast.error('Failed to send WhatsApp message. Please try again.');
         return res.data;
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response.data.message);
      }
      throw err; // Re-throw to handle in the component
   }
};

export const sendWhatsAppPdf = (params) => async (dispatch) => {
   try {
      console.log('Sending WhatsApp message with data:', typeof params.companyId, params.companyId);
      const res = await axios.get('/sales-invoice/getPdf', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_WP_MESSAGE_PDF, payload: res.data.data });
         toast.success('WhatsApp message sent successfully!');
         return res.data; // Return the result for handling in the component
      }
   } catch (err) {
      if (err.response?.data?.message) {
         // toast.error(err.response.data.message);
      }
      throw err; // Re-throw to handle in the component
   }
};

export const getGstAuth = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/settings/gstAuth', { params });
      if (res.data.code === 1) {
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
